import { z } from 'zod'

// ─── Login ────────────────────────────────────────────────────────────────────

export const loginSchema = z.object({
  email: z
    .string({ required_error: 'E-mail é obrigatório' })
    .email('E-mail inválido'),
  password: z
    .string({ required_error: 'Senha é obrigatória' })
    .min(6, 'A senha deve ter pelo menos 6 caracteres'),
})

export type LoginFormData = z.infer<typeof loginSchema>

// ─── Register ─────────────────────────────────────────────────────────────────

export const registerSchema = z
  .object({
    full_name: z
      .string({ required_error: 'Nome completo é obrigatório' })
      .min(3, 'O nome deve ter pelo menos 3 caracteres')
      .max(100, 'O nome deve ter no máximo 100 caracteres'),
    email: z
      .string({ required_error: 'E-mail é obrigatório' })
      .email('E-mail inválido'),
    password: z
      .string({ required_error: 'Senha é obrigatória' })
      .min(6, 'A senha deve ter pelo menos 6 caracteres'),
    confirmPassword: z
      .string({ required_error: 'Confirmação de senha é obrigatória' }),
    role: z.enum(['student', 'instructor'], {
      required_error: 'Selecione um perfil',
      invalid_type_error: 'Perfil inválido',
    }),
    phone: z
      .string()
      .regex(
        /^\+?[\d\s\-().]{10,20}$/,
        'Número de telefone inválido',
      )
      .optional()
      .or(z.literal('')),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'As senhas não conferem',
    path: ['confirmPassword'],
  })

export type RegisterFormData = z.infer<typeof registerSchema>
